var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatasetVirtual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 16,
    height: 16,
    fill: "#136478"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2.5H3C2.44772 2.5 2 2.94772 2 3.5V21.5C2 22.0523 2.44772 22.5 3 22.5H21C21.5523 22.5 22 22.0523 22 21.5V3.5C22 2.94772 21.5523 2.5 21 2.5ZM8 20.5H4V16.5H8V20.5ZM8 14.5H4V10.5H8V14.5ZM8 8.5H4V4.5H8V8.5ZM14 20.5H10V16.5H14V20.5ZM14 14.5H10V10.5H14V14.5ZM14 8.5H10V4.5H14V8.5ZM20 20.5H16V16.5H20V20.5ZM20 14.5H16V10.5H20V14.5ZM20 8.5H16V4.5H20V8.5Z",
    fill: "#A5DBE9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetVirtual);
export default ForwardRef;